import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Product from './common/Product'
import './style.css';  // You can add styles for smooth transitions 
import ProductsLink from './common/ProductsLink';
import useProduct from '../../Hook/useProduct';

function AllProducts() {
    const [searchVisible, setSearchVisible] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const toggleSearch = () => {
        setSearchVisible(!searchVisible); // Toggles search bar visibility
    };

    const { products, loading, getAllProducts } = useProduct()

    useEffect(() => {
        getAllProducts()
    }, [])


    return (
        <Box sx={{ width: '100%', my: 1 }}>
            {/* Animated Search Bar Box */}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'all 0.5s ease-in-out',  // Smooth transition
                }}
            >
                {/* Button to toggle search bar */}
                <Button onClick={toggleSearch} variant="outlined" sx={{
                    my: 2,
                    color: 'black', // Text color
                    borderColor: 'black', // Default border color
                    '&:hover': {
                        borderColor: '#f5b600', // Border color on hover
                        backgroundColor: '#f5b600', // Background color on hover
                        color: 'black', // Text color on hover
                    },
                    '&.Mui-focused': {
                        borderColor: '#f5b600', // Border color when focused
                    },
                }}>
                    {searchVisible ? 'Hide Search' : 'Search Products'}
                </Button>

                {/* Search Input Field */}
                <Box
                    sx={{
                        width: searchVisible ? '50%' : '0%',
                        opacity: searchVisible ? 1 : 0,
                        transition: 'width 0.5s ease-in-out, opacity 0.5s ease-in-out',
                        overflow: 'hidden',
                        mb: 2,
                    }}
                >
                    <TextField
                        /* sx={{
                            my: 1,
                            mt: 2,
                            background: 'transparent',
                            borderRadius: 1,
                            input: {
                                color: 'white', // Text color
                            },
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: 'white', // Default border color
                                },
                                '&:hover fieldset': {
                                    borderColor: '#f5b600', // Border color on hover
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#f5b600', // Border color when focused
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: 'white', // Default label color
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                                color: '#f5b600', // Label color when focused
                            },
                        }} */
                        fullWidth
                        variant="outlined"
                        placeholder="Search for products..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </Box>
            </Box>


            {/* Products Grid */}
            <Grid container spacing={2} sx={{ px: 5 }}>
                {products?.map((item, ind) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={ind} >
                            <Box sx={{ width: '100%', height: '500px', display: 'flex', justifyContent: 'center', }} >
                                <Product item={item} />
                            </Box>
                        </Grid>
                    )
                })}
                {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', height: '500px', display: 'flex', justifyContent: 'center', }} >
                        <Product />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', height: '500px', display: 'flex', justifyContent: 'center', }} >
                        <Product />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', height: '500px', display: 'flex', justifyContent: 'center', }} >
                        <Product />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Box sx={{ width: '100%', height: '500px', display: 'flex', justifyContent: 'center', }} >
                        <Product />
                    </Box>
                </Grid> */}
            </Grid>
        </Box >
    )
}

export default AllProducts